import { render, staticRenderFns } from "./payProblem.vue?vue&type=template&id=69c93cbe&scoped=true&"
var script = {}
import style0 from "./payProblem.vue?vue&type=style&index=0&id=69c93cbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c93cbe",
  null
  
)

export default component.exports